import './index.scss';

export default class WidgetAccordion {
  constructor(root) {
    this.root = root;

    this.items = this.root.querySelectorAll('.accordion-item');
    this.items.forEach((item) => { this.initItem(item); });
  }

  initItem(item) {
    const link = item.querySelector('.item-link');
    const pane = item.querySelector('.item-pane');

    link.addEventListener('click', (event) => {
      event.preventDefault();

      if (item.classList.contains('opened')) {
        item.classList.remove('opened');
        pane.style.maxHeight = null;
      } else {
        this.closeAll();

        item.classList.add('opened');
        pane.style.maxHeight = pane.scrollHeight + 'px';
      }
    });
  }

  closeAll() {
    this.items.forEach((item) => {
      const pane = item.querySelector('.item-pane');

      if (item.classList.contains('opened')) {
        item.classList.remove('opened');
        pane.style.maxHeight = null;
      }
    });
  }
}
